module.exports = "pegasus/assets/tech/small/3.jpg";